import { __assign } from "tslib";
import React from "react";
import classNames from "classnames";
import { ReactRouterActionItem } from "./reactRouterHelper";
export var ActionItem = function (_a) {
  var _b = _a.item,
      Icon = _b.icon,
      linkProps = _b.linkProps,
      onClick = _b.onClick,
      href = _b.href,
      disabled = _b.disabled,
      active = _b.active,
      NavLink = _a.NavLink;
  return Icon ? linkProps ? React.createElement(NavLink, __assign({
    component: ReactRouterActionItem
  }, linkProps, {
    disabled: disabled,
    exact: true
  }), React.createElement(Icon, null)) : React.createElement("li", {
    className: classNames("nav-icon-item", {
      active: active
    })
  }, React.createElement("a", {
    className: classNames("nav-icon", {
      disabled: disabled
    }),
    href: href,
    onClick: !disabled ? onClick : undefined
  }, React.createElement(Icon, null))) : null;
};